<template>
  <div>
    <gg-loading v-if="setUp === null" :loading="true" type="card" />
    <!-- Create opens a modal; once a forwarder exists the list takes over
         (AM-1107). -->
    <feature-setup v-else-if="!setUp" feature="forwarders" @create="creating = true" />
    <!-- The list alone, with Create in its header rather than a create form
         above it. -->
    <email-forwarders-table v-else title="Forwarders" :pending="pending" @update="loadForwarders">
      <template v-slot:header-actions>
        <gg-btn secondary small class="my-1" @click="creating = true">
          <v-icon left small>mdi-plus</v-icon>Create Forwarder
        </gg-btn>
      </template>
    </email-forwarders-table>

    <create-account-forwarder-modal
      :is-active="creating"
      :service="service"
      :scope-domain="$route.params.maindomain"
      @created="onCreated"
      @close="creating = false"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EmailForwardersTable from '@/components/Services/Hosting/Shared/Email/Forwarders/EmailForwardersTable'
import FeatureSetup from '@/components/Email/FeatureSetup'
import CreateAccountForwarderModal from '@/components/Email/CreateAccountForwarderModal'
import emailFeatureSetup from '@/mixins/emailFeatureSetup'

// The hosting section's Forwarders list, shown inside an email account, behind
// the empty state while the account has none.
export default {
  name: 'AccountForwardersView',
  components: { EmailForwardersTable, FeatureSetup, CreateAccountForwarderModal },
  mixins: [emailFeatureSetup('hasForwarders')],
  // Passed down by EmailAccountView, which has already pointed the hosting
  // context at this account's service.
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      creating: false,
      pending: true,
    }
  },
  methods: {
    ...mapActions({
      setForwarderDomain: 'email/setForwarderDomain',
      setForwarders: 'email/setForwarders',
      reportError: 'reportError',
    }),
    // What EmailForwarder does for the hosting section: no domain, so every
    // forwarder on the service is listed.
    async loadForwarders () {
      this.pending = true
      this.setForwarderDomain()
      try {
        await this.setForwarders({
          domain: undefined,
          _username: this.$route.query.user,
        })
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    },
    // From the empty state the `setUp` watcher does the reading.
    onCreated () {
      if (this.setUp) this.loadForwarders()
      else this.startSetUp()
    },
  },
  watch: {
    // Read once the list is about to show, and again on a service switch.
    setUp (val) {
      if (val) this.loadForwarders()
    },
  },
}
</script>
